export enum ScholarshipChangeStateDataConsts {
  SCHOLARSHIP_GET_ALLOWED_STATES = 'SCHOLARSHIP:GET:ALLOWED:STATES',
  SCHOLARSHIP_GET_ALLOWED_STATES_OK = 'SCHOLARSHIP:GET:ALLOWED:STATES:OK',

  SCHOLARSHIP_CHANGE_STATE = 'SCHOLARSHIP:CHANGE:STATE',

  SCHOLARSHIP_CHANGE_STATES_KO = 'SCHOLARSHIP:CHANGE:STATE:KO',
}
